var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSnorkler30Px(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    fill: "#00f",
    r: 15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.29 19.3h-1c-3.75-.16-7-.31-7.34-4.49a4.13 4.13 0 0 1 .81-3c1.06-1.28 3.32-1.81 7.53-1.81 4.21 0 6.47.58 7.56 1.83a4.08 4.08 0 0 1 .81 3c-.35 4.24-3.59 4.39-7.34 4.55zm0-8.25c-3.75 0-5.89.49-6.73 1.46a3 3 0 0 0 -.56 2.22c.24 2.91 1.92 3.26 6.29 3.46h2c4.37-.2 6.05-.56 6.29-3.53a2.94 2.94 0 0 0 -.58-2.15c-.82-.97-3-1.43-6.71-1.46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.38 18.93a5.6 5.6 0 0 1 -2.83-2.93c-.49-.9-.82-1.45-1.28-1.45s-.8.55-1.3 1.46a5.56 5.56 0 0 1 -2.82 2.93l-.38-1a4.6 4.6 0 0 0 2.23-2.47c.55-1 1.11-2 2.26-2s1.7 1 2.25 2a4.54 4.54 0 0 0 2.24 2.44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.84 23.76-.77-.76.27-.27a5.57 5.57 0 0 0 1.64-4v-8a5.57 5.57 0 0 0 -1.64-4l.78-.73a6.67 6.67 0 0 1 2 4.75v8a6.67 6.67 0 0 1 -2 4.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.75 22.25h2.45v3.26h-2.45z",
    transform: "matrix(.67507533 -.73774881 .73774881 .67507533 -11.13 22.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.03 4.48h2.45v3.26h-2.45z",
    transform: "matrix(.67507533 -.73774881 .73774881 .67507533 2.07 16.93)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnorkler30Px);
export default __webpack_public_path__ + "static/media/Snorkler-30px.5549a8cd9193965e64001a34d4e51c0c.svg";
export { ForwardRef as ReactComponent };